import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import { classNames } from "./formatters";

export const inputClass = (
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>>,
  className?: string,
  disabled?: boolean
) =>
  classNames(
    "shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full text-input border-gray-300 rounded-md leading-5",
    error ? "ring-2 ring-red-500 ring-offset-2 ring-offset-white" : "",
    disabled ? "bg-gray-100" : "",
    className
  );
